import $ from 'jquery';

export default function () {
  var $main = $('.main');
  var $links = $('.footer__game-link a');
  var $tabContents = $('.footer__game-ratingimg');

  $links.bind('click', function (e) {
    var id = $(this).attr('href');
    e.preventDefault();
    $links.removeClass('on');
    $(this).addClass('on');
    $tabContents.removeClass('visible').hide();
    $(id).show();
    setTimeout(function () {
      $(id).addClass('visible');
    }, 25);
  });

  if ($main.hasClass('main--matgo')) {
    $links.eq(1).click();
  } else if ($main.hasClass('main--gostop')) {
    $links.eq(2).click();
  } else {
    $links.eq(0).click();
  }
}
